import { render } from "./toDoText.vue?vue&type=template&id=15fa15de&ts=true"
import script from "./toDoText.vue?vue&type=script&lang=ts"
export * from "./toDoText.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__